import { FileObject } from '@highways/hooks/useUploadImage';

export const findDeletedImage = (
  initialFiles: FileObject[],
  remainingFiles: File[],
): FileObject | null => {
  const deletedFile = initialFiles.filter(({ file }) => {
    // check if remaining files contain the initial file
    return !remainingFiles.some((remainingFile) => {
      return file.name === remainingFile.name;
    });
  });
  if (deletedFile.length === 0) {
    return null;
  } else {
    return deletedFile[0];
  }
};
